import { useEffect, useRef, useState } from 'react';
import { useContent } from '@/content';
import { Editable } from '@/content/design';

export default function LogoHero() {
  const c = useContent();
  const [loaded, setLoaded] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const scrollDown = () => {
    const about = document.getElementById('about');
    if (about) {
      about.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      ref={sectionRef}
      className="relative min-h-[100dvh] flex flex-col items-center justify-center bg-gradient-blush overflow-hidden"
    >
      {/* Subtle decorative elements */}
      <div className="absolute top-20 left-10 w-32 h-32 rounded-full bg-champagne-100/30 blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 rounded-full bg-blush-200/20 blur-3xl"></div>

      <div className={`text-center z-10 transition-all duration-1000 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
        {/* Script Logo Text */}
        <Editable as="h1" id="hero.title" label="Start – Logo-Schriftzug" className="font-script text-7xl sm:text-8xl md:text-9xl lg:text-[10rem] text-gray-800 leading-none mb-2">
          {c.hero.title}
        </Editable>

        {/* Subtitle line */}
        <div className="flex items-center justify-center gap-4 mb-4">
          <span className="w-12 md:w-20 h-[1px] bg-champagne-400"></span>
          <span className="w-1.5 h-1.5 rounded-full bg-champagne-400"></span>
          <span className="w-12 md:w-20 h-[1px] bg-champagne-400"></span>
        </div>

        {/* Name */}
        <Editable as="p" id="hero.name" label="Start – Name" className="text-xs sm:text-sm tracking-[0.4em] uppercase text-gray-500 font-medium">
          {c.hero.name}
        </Editable>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollDown}
        className={`absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-gray-400 hover:text-champagne-500 transition-all duration-500 cursor-pointer ${loaded ? 'opacity-100' : 'opacity-0'}`}
        aria-label="Nach unten scrollen"
      >
        <span className="text-xs tracking-widest uppercase font-light">{c.hero.scroll}</span>
        <div className="w-6 h-10 rounded-full border border-gray-300 flex items-start justify-center pt-2">
          <div className="w-1 h-2.5 bg-champagne-400 rounded-full animate-bounce"></div>
        </div>
      </button>
    </section>
  );
}